import { Component, inject, OnDestroy } from '@angular/core';
import { AccountFilterData, WidgetFilterData } from '../../_shared/models';
import { AccountFilterComponent } from '../../_shared/components/filters/account-filter/account-filter.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService, FilterService } from '../../_shared/services';
import { Subject, Observable, filter, takeUntil } from 'rxjs';
import { RouterModule } from '@angular/router';
import { DriversInYardModalComponent } from '../dashboard/components/modals/drivers-in-yard-modal/drivers-in-yard-modal.component';
import { DriversInVehicleModalComponent } from '../dashboard/components/modals/drivers-in-vehicle-modal/drivers-in-vehicle-modal.component';
import { DriversEnRouteModalComponent } from '../dashboard/components/modals/drivers-en-route-modal/drivers-en-route-modal.component';
import { StationaryDriversModalComponent } from '../dashboard/components/modals/stationary-drivers-modal/stationary-drivers-modal.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-driver-manager',
  standalone: true,
  imports: [
    AccountFilterComponent,
    DriversInYardModalComponent,
    DriversInVehicleModalComponent,
    DriversEnRouteModalComponent,
    StationaryDriversModalComponent,
    CommonModule,
    FormsModule,
    RouterModule,
    TranslocoDirective
  ],
  templateUrl: './driver-manager.component.html',
  styleUrl: './driver-manager.component.scss',
})
export class DriverManagerComponent implements OnDestroy {
  public accountFilter: AccountFilterData = {} as AccountFilterData;
  public expandedComponentId: string | null = null;
  private ngDestroy$ = new Subject<void>(); // For automatic cleanup
  public searchTerm: string;
  public searchSubject = new Subject<string>();
  private refreshIntervalId: any;
  private filterService = inject(FilterService);
  private auth = inject(AuthService);

  ngOnInit(): void {
    const refreshTime = this.auth.getUserSettings()?.dashboardRefreshTime;
    if (refreshTime) {
      this.startRefreshInterval(refreshTime);
    }
  }

  onAccountFilterChange(filterData: AccountFilterData) {
    this.accountFilter = filterData;
    this.filterService.updateFilter(filterData as WidgetFilterData);
  }

  public onToggleExpand(event: any): void {
    const componentId: string = event as string;
    if (this.expandedComponentId === componentId) {
      // Collapsing
      this.expandedComponentId = null;
      this.searchTerm = '';
    } else {
      // Expanding
      this.expandedComponentId = componentId;
      this.searchTerm = '';
      this.searchSubject.next('');
    }
  }

  public getSearchObservable(componentId: string): Observable<string> {
    return this.searchSubject.pipe(
      filter(() => this.expandedComponentId === componentId),
      takeUntil(this.ngDestroy$)
    );
  }

  private startRefreshInterval(seconds: number) {
    this.refreshIntervalId = setInterval(() => {
      this.onAccountFilterChange(this.accountFilter);
    }, seconds * 1000);
  }

  ngOnDestroy(): void {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }

    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}